export interface BackgroundPackage {
    id: string;
    name: string;
    price: number;
    description: string;
    preview: string;
    popular?: boolean;
    sale?: {
        isActive: boolean;
        salePrice: number;
        saleBadge?: string;
        saleEnds?: string;
    };
}

export const BACKGROUND_PACKAGES: BackgroundPackage[] = [
    // --- Defaults ---
    {
        id: 'default',
        name: 'Default Light',
        price: 0,
        description: 'Clean slate dot grid',
        preview: 'radial-gradient(#cbd5e1 1.5px, transparent 1.5px) 0 0 / 24px 24px, #f8fafc',
        popular: false
    },
    {
        id: 'dark_mode',
        name: 'Default Dark',
        price: 0,
        description: 'Premium dark dot grid',
        preview: 'radial-gradient(#334155 1.5px, transparent 1.5px) 0 0 / 24px 24px, #020617',
        popular: false
    },
    // --- Premium Collection ---
    {
        id: 'bg-aurora',
        name: 'Aurora Borealis',
        price: 299,
        description: 'Ethereal northern lights with starfield',
        preview: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTAwJScgaGVpZ2h0PScxMDAlJyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnPjxkZWZzPjxsaW5lYXJHcmFkaWVudCBpZD0nYScgeDE9JzAlJyB5MT0nMCUnIHgyPScxMDAlJyB5Mj0nMCUnPjxzdG9wIG9mZnNldD0nMCUnIHN0b3AtY29sb3I9JyMzMTJlODEnIHN0b3Atb3BhY2l0eT0nMCcvPjxzdG9wIG9mZnNldD0nNTAlJyBzdG9wLWNvbG9yPScjN2MzYWVkJyBzdG9wLW9wYWNpdHk9JzAuMScvPjxzdG9wIG9mZnNldD0nMTAwJScgc3RvcC1jb2xvcj0nIzMxMmU4MScgc3RvcC1vcGFjaXR5PScwJy8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHJlY3Qgd2lkdGg9JzEwMCUnIGhlaWdodD0nMTAwJScgZmlsbD0ndXJsKCNhKScvPjxwYXRoIGQ9J00wIDEwMCBRIDI1MCA1MCA1MDAgMTAwIFQgMTAwMCAxMDAnIHN0cm9rZT0ncmdiYSgxMzksIDkyLCAyNDYsIDAuMSknIGZpbGw9J25vbmUnIHN0cm9rZS13aWR0aD0nMicvPjxjaXJjbGUgY3g9JzEwMCcgY3k9JzEwMCcgcj0nMScgZmlsbD0nd2hpdGUnIGZpbGwtb3BhY2l0eT0nMC41Jy8+PGNpcmNsZSBjeD0nMzAwJyBjeT0nNTAnIHI9JzEuNScgZmlsbD0nd2hpdGUnIGZpbGwtb3BhY2l0eT0nMC4zJy8+PGNpcmNsZSBjeD0nODAwJyBjeT0nMjAwJyByPScxJyBmaWxsPSd3aGl0ZScgZmlsbC1vcGFjaXR5PScwLjYnLz48Y2lyY2xlIGN4PSc1MDAnIGN5PSczMDAnIHI9JzEnIGZpbGw9J3doaXRlJyBmaWxsLW9wYWNpdHk9JzAuNCcvPjwvc3ZnPg=="), radial-gradient(circle at 50% 100%, #1e1b4b 0%, #020617 100%)',
        popular: true
    },
    {
        id: 'bg-holographic',
        name: 'Holographic Mist',
        price: 199,
        description: 'Iridescent flow with organic shapes',
        preview: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTAwJyBoZWlnaHQ9JzEwMCcgdmlld0JveD0nMCAwIDEwMCAxMDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PGcgZmlsbD0nI2UwZTdmZicgZmlsbC1vcGFjaXR5PScwLjQnPjxjaXJjbGUgY3g9JzExJyBjeT0nMTgnIHI9JzcnLz48Y2lyY2xlIGN4PSc1OScgY3k9JzQzJyByPSc3Jy8+PGNpcmNsZSBjeD0nMTYnIGN5PSczNicgcj0nMycvPjxjaXJjbGUgY3g9JzYzJyBjeT0nMzEnIHI9JzMnLz48Y2lyY2xlIGN4PSczNCcgY3k9JzkwJyByPSczJy8+PGNpcmNsZSBjeD0nOTAnIGN5PSc2Micgcj0nMycvPjxjaXJjbGUgY3g9JzEyJyBjeT0nODYnIHI9JzQnLz48Y2lyY2xlIGN4PSc0MCcgY3k9JzIxJyByPSc0Jy8+PGNpcmNsZSBjeD0nNjMnIGN5PSc4MCcgcj0nNScvPjxjaXJjbGUgY3g9JzM3JyBjeT0nNjAnIHI9JzQnLz48Y2lyY2xlIGN4PSc5NCcgY3k9Jzg0JyByPSc1Jy8+PGNpcmNsZSBjeD0nMzInIGN5PSc2Mycgcj0nNScvPjxjaXJjbGUgY3g9Jzg5JyBjeT0nNTAnIHI9JzUnLz48Y2lyY2xlIGN4PSc4MCcgY3k9JzI5JyByPScyJy8+PGNpcmNsZSBjeD0nNjAnIGN5PSc5MScgcj0nMicvPjxjaXJjbGUgY3g9JzM1JyBjeT0nNDEnIHI9JzInLz48Y2lyY2xlIGN4PScxMicgY3k9JzYwJyByPScyJy8+PC9nPjwvc3ZnPg=="), linear-gradient(135deg, #fdf4ff 0%, #fae8ff 100%)',
        popular: false
    },
    {
        id: 'bg-synthwave',
        name: 'Synthwave Grid',
        price: 199,
        description: 'Neon retro perspective grid',
        preview: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTAwJyBoZWlnaHQ9JzEwMCcgdmlld0JveD0nMCAwIDEwMCAxMDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSdhJyB4MT0nMCUnIHkxPScwJScgeDI9JzAlJyB5Mj0nMTAwJSc+PHN0b3Agb2Zmc2V0PScwJScgc3RvcC1jb2xvcj0nI2MwMjZkMycgc3RvcC1vcGFjaXR5PScwLjEnLz48c3RvcCBvZmZzZXQ9JzEwMCUnIHN0b3AtY29sb3I9JyNjMDI2ZDMnIHN0b3Atb3BhY2l0eT0nMC40Jy8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHBhdGggZD0nTTAgMCBMMTAwIDAgTDEwMCAxMDAgTDAgMTAwIFonIGZpbGw9J25vbmUnIHN0cm9rZT0ndXJsKCNhKScgc3Ryb2tlLXdpZHRoPScxJyAvPjwvc3ZnPg=="), linear-gradient(180deg, #2a0a2e 0%, #0f172a 100%)',
        popular: false
    },
    {
        id: 'bg-royal',
        name: 'Royal Velvet',
        price: 249,
        description: 'Luxurious damask pattern in plum',
        preview: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nNjAnIGhlaWdodD0nNjAnIHZpZXdCb3g9JzAgMCA2MCA2MCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JmLzIwMDAvc3ZnJz48ZyBmaWxsPSdub25lJyBmaWxsLXJ1bGU9J2V2ZW5vZGQnPjxnIGZpbGw9JyM5MzMzZWEnIGZpbGwtb3BhY2l0eT0nMC4wNSc+PHBhdGggZD0nTTM2IDM0di00aC0ydjRoLTR2Mmg0djRoMnYtNGg0di0yaC00em0wLTMwVjBoLTJ2NGgtNHYyaDR2NGgyVjZoNFY0aC00ek02IDM0di00SDR2NEgwdjJoNHY0aDJ2LTRoNHYtMkg2ek02IDRWMEg0djRIMHYyaDR2NGgyVjZoNFY0SDZ6Jy8+PC9nPjwvZz48L3N2Zyg+"), radial-gradient(circle at 50% 50%, #2e1065 0%, #1e1b4b 100%)',
        popular: false
    },
    {
        id: 'bg-golden',
        name: 'Golden Noir',
        price: 499,
        description: 'Art deco geometric gold luxury',
        preview: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nNDAnIGhlaWdodD0nNDAnIHZpZXdCb3g9JzAgMCA0MCA0MCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JmLzIwMDAvc3ZnJz48ZyBmaWxsPScjZDk3NzA2JyBmaWxsLW9wYWNpdHk9JzAuMScgZmlsbC1ydWxlPSdldmVub2RkJz48cGF0aCBkPSdNMCA0MEw0MCAwSDIwTDAgMjBNNDAgNDBWMjBMMjAgNDAnLz48L2c+PC9zdmc+"), linear-gradient(135deg, #0f172a 0%, #172554 100%)',
        popular: true
    },
    {
        id: 'bg-midnight-forest',
        name: 'Midnight Forest',
        price: 149,
        description: 'Deep green foliage pattern',
        preview: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjAnIGhlaWdodD0nMjAnIHZpZXdCb3g9JzAgMCAyMCAyMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JmLzIwMDAvc3ZnJz48cGF0aCBkPSdNMSAxaDJ2MkgxVjF6bTQgNGgydjJINVY1em00LTRoMnYySDlWMXpNNSAxaDJ2Mkg1VjF6bS00IDRoMnYySDFVNXonIGZpbGw9JyMxMGI5ODEnIGZpbGwtb3BhY2l0eT0nMC4wNScgZmlsbC1ydWxlPSdldmVub2RkJy8+PC9zdmc+"), linear-gradient(to bottom, #022c22, #064e3b)',
        popular: false
    },
    {
        id: 'bg-obsidian',
        name: 'Obsidian Flow',
        price: 399,
        description: 'Abstract topographic dark lines',
        preview: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTAwJyBoZWlnaHQ9JzEwMCcgdmlld0JveD0nMCAwIDEwMCAxMDAnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PHBhdGggZD0nTTExIDE4YzMuODY2IDAgNy0zLjEzNCA3LTdzLTMuMTM0LTctNy03LTcgMy4xMzQtNyA3IDMuMTM0IDcgNyA3em00OCAyNWMzLjg2NiAwIDctMy4xMzQgNy03cy0zLjEzNC03LTctNy03IDMuMTM0LTcgNyAzLjEzNCA3IDcgN3ptLTQzLTdjMS42NTcgMCAzLTEuMzQzIDMtM3MtMS4zNDMtMy0zLTMtMyAxLjM0My0zIDMgMS4zNDMgMyAzIDN6bTYzIDMxYzEuNjU3IDAgMy0xLjM0MyAzLTNzLTEuMzQzLTMtMy0zLTMgMS4zNDMtMyAzIDEuMzQzIDMgMyAzek0xMiA4NmMyLjIxIDAgNC0xLjc5IDQtNHMtMS43OS00LTQtNC00IDEuNzktNCA0IDEuNzkgNCA0IDR6bTI4LTY1YzIuMjEgMCA0LTEuNzkgNC00cy0xLjc5LTQtNC00LTQgMS43OS00IDQgMS43OSAzIDQgNHptMjMtMTFjMi43NiAwIDUtMi4yNCA1LTVzLTIuMjQtNS01LTUtNSAyLjI0LTUgNSA1IDIuMjQgNSA1IDV6bS02IDYwYzIuMjEgMCA0LTEuNzkgNC00cy0xLjc5LTQtNC00LTQgMS43OS00IDQgMS43OSA0IDQgNHptMjkgMjJjMi43NiAwIDUtMi4yNCA1LTVzLTIuMjQtNS01LTUtNSAyLjI0LTUgNSA1IDIuMjQgNSA1IDV6TTMyIDYzYzIuNzYgMCA1LTIuMjQgNS01cy0yLjI0LTUtNS01LTUgMi4yNC01IDUgMi4yNCA1IDUgNXptNTctMTNjMi43NiAwIDUtMi4yNCA1LTVzLTIuMjQtNS01LTUtNSAyLjI0LTUgNSA1IDIuMjQgNSA1IDV6bS05LTIxYzEuMTA1IDAgMi0uODk1IDItMnMtL445NS0yLTItMi0yIC44OTUtMiAyIC44OTUgMiAyIDJ6TTYwIDkxYzEuMTA1IDAgMi0uODk1IDItMnMtLjg5NS0yLTItMi0yIC44OTUtMiAyIC44OTUgMiAyIDJ6TTM1IDQxYzEuMTA1IDAgMi0uODk1IDItMnMtLjg5NS0yLTItMi0yIC44OTUtMiAyIC44OTUgMiAyIDJ6TTEyIDYwYzEuMTA1IDAgMi0uODk1IDItMnMtLjg5NS0yLTItMi0yIC44OTUtMiAyIC44OTUgMiAyIDJ6JyBmaWxsPScjZmZmZmZmJyBmaWxsLW9wYWNpdHk9JzAuMDMnIGZpbGwtcnVsZT0nZXZlbm9kZCcvPjwvc3ZnPg=="), linear-gradient(45deg, #0f172a 0%, #030712 100%)',
        popular: true
    },
    {
        id: 'bg-matrix',
        name: 'Digital Rain',
        price: 249,
        description: 'Binary code rain pattern',
        preview: 'url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nNjAnIGhlaWdodD0nMzAnIHZpZXdCb3g9JzAgMCA2MCAzMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JmLzIwMDAvc3ZnJz48ZyBmaWxsPScjMjJjNTVlJyBmaWxsLW9wYWNpdHk9JzAuMic+PHBhdGggZD0nTTAgMGgydjEwSDBWMHptNCA1aDJ2Nkg0VjV6bTIwIDBoMnY4aC0yVjV6bTYtNGgydjZoLTJWMXpNMjggNmgydjZoLTJWNnptOC01aDJ2OWgtMlYxem0xMiAxaDJ2NWgtMlY2em00LTJoMnY2aC0yVjB6TTggMTJoMnY2SDh2LTZ6bTEyIDJoMnY5aC0ydi05em0tNiAyaDJ2NWgtMnYtNXptMjQgMWgydjloLTJ2LTl6bTQtMmgydjZoLTJ2LTZ6Jy8+PC9nPjwvc3ZnPg=="), linear-gradient(180deg, #001e00 0%, #000000 100%)',
        popular: false
    },
    // --- New Expanded Collection ---
    {
        id: 'bg-cherry-blossom',
        name: 'Cherry Blossom',
        price: 199,
        description: 'Soft pink petals on warm cream',
        preview: 'radial-gradient(circle at 20% 30%, rgba(251,191,210,0.4) 0%, transparent 50%), radial-gradient(circle at 80% 70%, rgba(244,163,187,0.3) 0%, transparent 50%), radial-gradient(circle at 50% 50%, rgba(252,231,243,0.2) 0%, transparent 60%), linear-gradient(135deg, #fdf2f8 0%, #fce7f3 50%, #fbcfe8 100%)',
        popular: true
    },
    {
        id: 'bg-cosmic-nebula',
        name: 'Cosmic Nebula',
        price: 349,
        description: 'Deep space nebula with star clusters',
        preview: 'radial-gradient(ellipse at 20% 50%, rgba(124,58,237,0.3) 0%, transparent 50%), radial-gradient(ellipse at 80% 20%, rgba(236,72,153,0.2) 0%, transparent 50%), radial-gradient(ellipse at 50% 80%, rgba(59,130,246,0.2) 0%, transparent 50%), linear-gradient(180deg, #030712 0%, #0f0720 50%, #020617 100%)',
        popular: true
    },
    {
        id: 'bg-ocean-depth',
        name: 'Ocean Depth',
        price: 199,
        description: 'Calming deep ocean gradient',
        preview: 'radial-gradient(ellipse at 50% 0%, rgba(14,165,233,0.15) 0%, transparent 60%), radial-gradient(ellipse at 30% 80%, rgba(6,182,212,0.1) 0%, transparent 50%), linear-gradient(180deg, #0c4a6e 0%, #082f49 40%, #0a1929 100%)',
        popular: false
    },
    {
        id: 'bg-sunset-gradient',
        name: 'Sunset Horizon',
        price: 249,
        description: 'Warm sunset tones blending together',
        preview: 'radial-gradient(ellipse at 50% 100%, rgba(251,146,60,0.2) 0%, transparent 50%), linear-gradient(180deg, #1e1b4b 0%, #312e81 20%, #7c2d12 60%, #ea580c 85%, #f97316 100%)',
        popular: false
    },
    {
        id: 'bg-paper-texture',
        name: 'Parchment',
        price: 99,
        description: 'Classic warm paper texture feel',
        preview: 'radial-gradient(circle at 50% 50%, rgba(217,196,160,0.15) 0%, transparent 70%), linear-gradient(135deg, #fefce8 0%, #fef3c7 30%, #fde68a 60%, #fef3c7 100%)',
        popular: false
    },
    {
        id: 'bg-minimal-dots',
        name: 'Minimal Dots',
        price: 99,
        description: 'Clean minimal dot pattern on white',
        preview: 'radial-gradient(circle, #e2e8f0 1px, transparent 1px) 0 0 / 20px 20px, linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        popular: false
    },
    {
        id: 'bg-blueprint',
        name: 'Blueprint',
        price: 199,
        description: 'Technical blueprint grid pattern',
        preview: 'linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px) 0 0 / 20px 20px, linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px) 0 0 / 20px 20px, linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px) 0 0 / 100px 100px, linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px) 0 0 / 100px 100px, #1e3a5f',
        popular: false
    },
    {
        id: 'bg-lavender-dream',
        name: 'Lavender Dream',
        price: 149,
        description: 'Soft lavender gradient with gentle glow',
        preview: 'radial-gradient(circle at 30% 20%, rgba(196,181,253,0.3) 0%, transparent 50%), radial-gradient(circle at 70% 80%, rgba(232,215,255,0.2) 0%, transparent 50%), linear-gradient(135deg, #f5f3ff 0%, #ede9fe 50%, #ddd6fe 100%)',
        popular: false
    },
    {
        id: 'bg-emerald-glass',
        name: 'Emerald Glass',
        price: 299,
        description: 'Frosted emerald glass with depth',
        preview: 'radial-gradient(ellipse at 50% 0%, rgba(16,185,129,0.15) 0%, transparent 60%), radial-gradient(ellipse at 80% 80%, rgba(5,150,105,0.1) 0%, transparent 40%), linear-gradient(160deg, #022c22 0%, #064e3b 30%, #065f46 60%, #047857 100%)',
        popular: false
    },
    {
        id: 'bg-rose-gold',
        name: 'Rose Gold',
        price: 349,
        description: 'Elegant rose gold metallic shimmer',
        preview: 'radial-gradient(ellipse at 30% 20%, rgba(251,191,210,0.2) 0%, transparent 50%), radial-gradient(ellipse at 70% 70%, rgba(217,119,87,0.15) 0%, transparent 50%), linear-gradient(135deg, #1c1917 0%, #292524 30%, #44403c 50%, #292524 70%, #1c1917 100%)',
        popular: true
    },
    {
        id: 'bg-arctic-frost',
        name: 'Arctic Frost',
        price: 199,
        description: 'Icy blue crystalline gradient',
        preview: 'radial-gradient(circle at 20% 80%, rgba(186,230,253,0.2) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(224,242,254,0.15) 0%, transparent 50%), linear-gradient(135deg, #e0f2fe 0%, #bae6fd 30%, #7dd3fc 60%, #bae6fd 100%)',
        popular: false
    },
    {
        id: 'bg-dark-carbon',
        name: 'Dark Carbon',
        price: 199,
        description: 'Carbon fiber texture on dark base',
        preview: 'repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(255,255,255,0.02) 2px, rgba(255,255,255,0.02) 4px), repeating-linear-gradient(-45deg, transparent, transparent 2px, rgba(255,255,255,0.02) 2px, rgba(255,255,255,0.02) 4px), linear-gradient(180deg, #18181b 0%, #09090b 100%)',
        popular: false
    },
    {
        id: 'bg-warm-sand',
        name: 'Warm Sand',
        price: 149,
        description: 'Desert sand warm neutral tones',
        preview: 'radial-gradient(circle at 50% 50%, rgba(253,230,138,0.1) 0%, transparent 60%), linear-gradient(180deg, #fef3c7 0%, #fde68a 30%, #fcd34d 60%, #fde68a 100%)',
        popular: false
    },
    {
        id: 'bg-neon-city',
        name: 'Neon City',
        price: 399,
        description: 'Cyberpunk neon glow on dark streets',
        preview: 'radial-gradient(circle at 30% 70%, rgba(236,72,153,0.15) 0%, transparent 40%), radial-gradient(circle at 70% 30%, rgba(59,130,246,0.15) 0%, transparent 40%), radial-gradient(circle at 50% 50%, rgba(168,85,247,0.1) 0%, transparent 50%), linear-gradient(180deg, #020617 0%, #0f172a 50%, #020617 100%)',
        popular: true
    }
];
